

import type { ClassDef, ClassId, Stats } from "./types";


function statsTemplate(keyStat: keyof Stats): Stats {
  const base: Stats = {
    strength: 5,
    dexterity: 5,
    intelligence: 5,
    wisdom: 5,
    constitution: 5,
  };
  base[keyStat] = 8;
  return base;
}

export const CLASS_DEFS: Record<ClassId, ClassDef> = {
  warrior: {
    id: "warrior",
    name: "Воин",
    keyStat: "strength",
    description: "Мастер клинка и щита. Ключевой стат — Сила.",
    domainIds: ["steel", "blood"],
    startingStats: statsTemplate("strength"),
    startingClassCards: ["basic_strike", "basic_defend", "battle_cry"],
  },

  priest: {
    id: "priest",
    name: "Жрец",
    keyStat: "wisdom",
    description: "Служитель богов. Ключевой стат — Мудрость.",
    domainIds: ["light", "darkness", "nature"],
    startingStats: statsTemplate("wisdom"),
    startingClassCards: ["basic_prayer", "basic_defend", "bark_skin"],
  },

  wizard: {
    id: "wizard",
    name: "Волшебник",
    keyStat: "intelligence",
    description: "Плетёт заклинания. Ключевой стат — Интеллект.",
    domainIds: ["fire", "ice", "shadow"],
    startingStats: statsTemplate("intelligence"),
    startingClassCards: ["basic_arcane_bolt", "basic_defend"],
  },
};


export const CLASS_ORDER: ClassId[] = ["warrior", "priest", "wizard"];


export function getClass(id: ClassId): ClassDef {
  const def = CLASS_DEFS[id];
  if (!def) throw new Error(`Unknown class id: ${id}`);
  return def;
}
